<template>
    <div class="leave-req-wrapper" v-if="is_dashboard == 'yes'">
        <div class="content-div-title mb-3 mt-4">Recent Leave Requests</div>
        <template v-if="count_leaves > 0">
            <table class="">
                <thead>
                    <tr class="table-head">
                        <th class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)" style="cursor:pointer;">{{column.label}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="table-row" v-for="(leave,n) in leaves" :key="n" v-if="n < 3">
                        <td class="font-semi-bold leave-type-cell">
                            <img v-if="leave.leave_type == 'Sick Leave'" v-bind:src="$api_url+'/images/menu/hospital.svg'" class="mr-1"/>
                            <img v-else-if="leave.leave_type == 'Casual Leave'" v-bind:src="$api_url+'/images/menu/plane.png'" class="mr-1"/>
                            <img v-else v-bind:src="$api_url+'/images/menu/clock.png'" class="mr-1"/>
                            {{leave.leave_type}}
                        </td>
                        <td class="text-center font-semi-bold">{{leave.from}}</td>
                        <td class="text-center font-semi-bold">{{leave.to}}</td>
                        <td class="text-center font-semi-bold">
                            <template v-if="leave.leave_day == 0">
                                {{ leave.number_of_days }}
                                <span v-if="leave.number_of_days > 1">days</span>
                                <span v-else>day</span>
                            </template>
                            <template v-else-if="leave.leave_day == 1">First Half</template>
                            <template v-else-if="leave.leave_day == 2">Second Half</template>
                        </td>
                        <td class="text-center font-semi-bold" :class="leave.status.toLowerCase()">
                            <span class="leave-status" v-if="leave.status == 'Applied'"><i class="fa fa-circle mr-1"></i>Pending</span>
                            <span class="leave-status" v-if="leave.status == 'Approved'"><i class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                            <span class="leave-status" v-if="leave.status == 'Declined'"><i class="fa fa-circle mr-1"></i>{{leave.status}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </template>
        <template v-else>
            No Leave Request Found.
        </template>
    </div>
    <div class="ibox custom-box" v-else>
        <div class="ibox-title dashboard_title">
            <h3>
                <img class="m-r-sm" :src="img_src + 'position.png'" width="16">
                Recent Leave Requests
            </h3>
        </div>
        <div class="ibox-content">
            <template v-if="count_leaves > 0">
                <table class="table dataTable">
                    <thead class="" style="">
                        <tr class="table-head">
                            <td class="" v-for="column in columns" :key="column.name" @click="sortBy(column.name)"
                                style="cursor:pointer;">{{ column.label }}</td>
                        </tr>
                    </thead>
                    <tbody>

                        <tr class="table-row hover-bg" v-for="(leave, n) in leaves" :key="n">

                            <td class="">
                                {{ leave.leave_type }}
                            </td>
                            <td class="">
                                {{ leave.from }}
                            </td>
                            <td class="">
                                {{ leave.to }}
                            </td>
                            <td class="">
                                <!-- {{leave.number_of_days}} 
                                    <span v-if="leave.number_of_days > 1">days</span>
                                    <span v-else>day</span> -->

                                <template v-if="leave.leave_day == 0">
                                    {{ leave.number_of_days }}
                                    <span v-if="leave.number_of_days > 1">days</span>
                                    <span v-else>day</span>
                                </template>
                                <template v-else-if="leave.leave_day == 1">First Half</template>
                                <template v-else-if="leave.leave_day == 2">Second Half</template>
                            </td>
                            <td class="">
                                <span class="leave-status" v-if="leave.status == 'Approved'"><i
                                        class="far fa-dot-circle mr-1 text-success"></i>{{ leave.status }}</span>
                                <span class="leave-status" v-if="leave.status == 'Applied'"><i
                                        class="far fa-dot-circle mr-1 text-primary"></i>Pending</span>
                                <span class="leave-status" v-if="leave.status == 'Declined'"><i
                                        class="far fa-dot-circle mr-1 text-danger"></i>{{ leave.status }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <template v-else>

                No Leave Request Found.

            </template>
        </div>
    </div>
</template>
<script>

export default {
    mounted() {
        this.$refs.trzcalendar;
    },

    props: ['is_dashboard'],
    components: {
    },
    data() {
        let sortOrders = {};
        let columns = [

            { label: 'Leave Type', name: 'leave_type' },
            { label: 'From', name: 'from' },
            { label: 'To', name: 'to' },
            { label: 'No. of Days', name: 'number_of_days' },
            { label: 'Status', name: 'status' },

        ];

        return {
            columns: columns,
            sortOrders: sortOrders,
            leaves: [],
            count_leaves: 0,
            cr: 0,


            page: { month: '', year: '' },
            img_src: this.$api_url + '/images/employee_dasboard/',
        }
    },
    methods: {


        getRecentLeaves: function () {
            if (!this.checkNet()) return false;
            this.employee_id = 0;
            let currentObj = this;
            axios.get(this.$api_url + '/front/employees/leaves/fiscalyear', {
                params: {
                    flg: 1
                }
            }).then(function (response) {
                this.leaves = response.data.leaves;
                this.count_leaves = response.data.leaves.length;
                console.log(this.count_leaves);

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },


        setMe: function (x) {
            this.cr = x;

        },


    },
    created: function () {
        this.getRecentLeaves();
    },

}

</script>
